// 2_components/footer_instagram.js
// Rebuilds the footer Instagram heading into a "Follow on Instagram @account" link
// derived from the existing Instagram follow button.

export function init() {
	editFooterInstagram();
}

function editFooterInstagram() {
	const footer = document.querySelector("#footer");
	if (!footer) return;

	const iGFooterButton = footer.querySelector(".instagram-follow-btn a");
	if (!iGFooterButton) return;

	const iGFooterButtonLink = iGFooterButton.getAttribute("href");
	if (!iGFooterButtonLink) return;

	const iGHeading = footer.querySelector("h3");
	if (!iGHeading) return;

	let accountName = iGFooterButtonLink.split("https://www.instagram.com/")[1];
	if (!accountName) return;
	if (accountName.endsWith("/")) {
		accountName = accountName.slice(0, -1);
	}

	const link = document.createElement("a");
	link.href = iGFooterButtonLink;
	link.target = "_blank";
	link.rel = "noopener";

	const followText = document.createElement("span");
	followText.className = "ig-follow-text";
	followText.textContent = window.NAT.translations("followOnInstagram");

	const accountNameSpan = document.createElement("span");
	accountNameSpan.className = "ig-account-name";
	accountNameSpan.textContent = accountName;

	link.appendChild(followText);
	link.appendChild(document.createTextNode(" "));
	link.appendChild(accountNameSpan);

	iGHeading.innerHTML = "";
	iGHeading.appendChild(link);
}
